import Vue from 'vue'

// 全局注册禁止表情输入的指令
const install = (Vue) => {
  Vue.directive('no-emoji', {
    // 绑定时
    bind(el, binding) {
      // 表情符号检测正则表达式
      const emojiRegex =
        /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu

      // 针对不同组件获取实际的输入元素
      const getInput = (el) => {
        if (el.tagName === 'INPUT') {
          return el
        }
        if (el.querySelector('input')) {
          return el.querySelector('input')
        }
        return el
      }

      // 初始处理函数
      const handleEl = (el) => {
        const input = getInput(el)

        if (input) {
          // 绑定事件处理
          input.addEventListener('input', (e) => {
            const cursorPos = e.target.selectionStart
            // 检测是否包含表情
            const hasEmoji = emojiRegex.test(e.target.value)

            if (hasEmoji) {
              // 记录原始值
              const beforeValue = e.target.value
              // 移除表情符号
              const afterValue = beforeValue.replace(emojiRegex, '')
              e.target.value = afterValue

              // 计算删除了多少个字符
              const removedChars = beforeValue.length - afterValue.length

              // 修正光标位置
              e.target.setSelectionRange(cursorPos - removedChars, cursorPos - removedChars)

              // 触发 input 事件以更新 Vue 模型
              e.target.dispatchEvent(new Event('input', { bubbles: true }))
            }
          })
        }
      }

      // 首次绑定处理
      handleEl(el)

      // 对于级联选择器等组件，需要等待搜索框出现
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            // 寻找新添加的搜索输入框
            const searchInputs = el.querySelectorAll('input')
            searchInputs.forEach((input) => {
              if (!input._hasNoEmojiListener) {
                input.addEventListener('input', (e) => {
                  if (emojiRegex.test(e.target.value)) {
                    const cursorPos = e.target.selectionStart
                    const oldValue = e.target.value
                    const newValue = oldValue.replace(emojiRegex, '')
                    e.target.value = newValue

                    // 修正光标位置
                    const charsRemoved = oldValue.length - newValue.length
                    e.target.setSelectionRange(cursorPos - charsRemoved, cursorPos - charsRemoved)

                    // 触发事件
                    e.target.dispatchEvent(new Event('input', { bubbles: true }))
                  }
                })
                input._hasNoEmojiListener = true
              }
            })
          }
        })
      })

      // 监听DOM变化，处理动态出现的输入框
      observer.observe(el, { childList: true, subtree: true })

      // 保存引用以便清理
      el._observer = observer
    },

    // 解绑时清理
    unbind(el) {
      if (el._observer) {
        el._observer.disconnect()
      }
    }
  })
}

Vue.use(install)

export default install
